module.exports = __webpack_public_path__ + "static/img/img_01.2f211143.png";